<template>
    <div>
        <!-- Label -->
        <label :for="field.id" class="block text-sm font-medium text-gray-700 mb-2">
            {{ field.label }}
            <span v-if="field.required" class="text-red-500">*</span>
        </label>

        <!-- Radio Options -->
        <div v-for="option in field.options" :key="option" class="flex items-center mb-2">
            <!-- Radio Input -->
            <input type="radio" :name="field.id" :id="`${field.id}_${option}`" :value="option"
                :checked="modelValue === option" @change="$emit('update:modelValue', option)"
                class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
            <!-- Label for each option -->
            <label :for="`${field.id}_${option}`" class="ml-3 block text-sm text-gray-700 cursor-pointer">
                {{ option }}
            </label>
        </div>

        <!-- Description -->
        <p v-if="field.description" class="text-xs text-gray-500 mt-1">
            {{ field.description }}
        </p>
    </div>
</template>


<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: String, // Ensure it's a String
            default: ''
        }
    }
};
</script>
